import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const fetchAllTeamMembers = createAsyncThunk('fetchAllTeamMembers', async (_, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/tpo/my-team`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const teamMembersSlice = createSlice({
    name: 'TPO',
    initialState: {
        loading: false,
        students: {},
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllTeamMembers.pending, (state, action) => {
            state.loading = true;
            state.students = {}
        })
        builder.addCase(fetchAllTeamMembers.fulfilled, (state, action) => {
            state.loading = false;
            state.students = action.payload
        })
        builder.addCase(fetchAllTeamMembers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default teamMembersSlice.reducer